export default "__VITE_ASSET__Bik$RiDK__"